import { IconButton } from '@mui/material'

const RoundedIconButton = (props) => {
  const { selected, onClick, icon, backgroundColor } = props
  return (
    <IconButton size='large' sx={{ padding: '50px', backgroundColor, outline: selected ? '3px solid black' : null, '&:hover': { backgroundColor, opacity: 0.8 }, opacity: selected ? 1 : 0.5 }} onClick={onClick}>
      {icon}
    </IconButton>
  )
}

export default RoundedIconButton
